import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';

const StepThree = ({ handleChange, otherDetailsObject, isValid }) => {
    const [localInput, setLocalInput] = useState({
        industry: otherDetailsObject.industry || '',
        size: otherDetailsObject.size || '',
        is_startup: otherDetailsObject.is_startup || false
    });

    const optionalKeys = ['industry'];

    useEffect(() => {
        validateInputs(localInput);
    }, [localInput]);

    const handleLocalChange = (key, value) => {
        setLocalInput(prev => ({ ...prev, [key]: value }));
    };

    const validateInputs = (inputs) => {
        let valid = true;

        // 'size' is mandatory, 'industry' is optional
        if (!inputs.size) valid = false;

        handleChange(inputs);
        isValid(valid ? { step: '2' } : false);
    };

    const industryOptions = [
        { label: 'Agriculture', value: 'Agriculture' },
        { label: 'Automobile', value: 'Automobile' },
        { label: 'Construction', value: 'Construction' },
        { label: 'Consulting', value: 'Consultation' },
        { label: 'Distribution', value: 'Distribution' },
        { label: 'E-commerce', value: 'E-commerce' },
        { label: 'Éducation', value: 'Éducation' },
        { label: 'Finance', value: 'Finance' },
        { label: 'Santé', value: 'Santé' },
        { label: 'Informatique & Logiciels', value: 'Informatique & Logiciels' },
        { label: 'Fabrication', value: 'Fabrication' },
        { label: 'Marketing', value: 'Marketing' },
        { label: 'Vente au détail', value: 'Vente au détail' },
        { label: 'Services', value: 'Services' },
        { label: 'Technologie', value: 'Technologie' },
        { label: 'Transport & Logistique', value: 'Transport & Logistique' },
        { label: 'Autre', value: 'Autre' }
    ];

    const sizeOptions = [
        { label: '1-20', value: '1-20' },
        { label: '20-50', value: '20-50' },
        { label: '50-100', value: '50-100' },
        { label: '100-200', value: '100-200' },
        { label: '200-500', value: '200-500' },
        { label: '+500', value: '+500' }
    ];

    return (
        <div>
            <div className="columns">
                <div className="column">
                    <label className="label">Votre industrie (optionnel)</label>
                    <Dropdown
                        value={localInput.industry}
                        options={industryOptions}
                        onChange={(e) => handleLocalChange('industry', e.value)}
                        placeholder="Votre industrie"
                        style={{ width: '100%', borderRadius: 4 }}
                        panelClassName='primereact-dropdown-spaced'
                    />
                </div>

                <div className="column">
                    <label className="label">Taille de votre entreprise *</label>
                    <Dropdown
                        value={localInput.size}
                        options={sizeOptions}
                        onChange={(e) => handleLocalChange('size', e.value)}
                        placeholder="Taille de l'entreprise"
                        style={{ width: '100%', borderRadius: 4 }}
                        panelClassName='primereact-dropdown-spaced'
                    />
                </div>
            </div>

            {localInput.size && parseInt(localInput.size) < 100 && (
                <div className="columns mt-2">
                    <div className="column">
                        <label className="label">Votre entreprise est-elle une Startup ? *</label>
                        <div className="control">
                            <label className="radio mr-3">
                                <input
                                    type="radio"
                                    name="is_startup"
                                    checked={localInput.is_startup === true}
                                    onChange={() => handleLocalChange('is_startup', true)}
                                /> Oui
                            </label>
                            <label className="radio">
                                <input
                                    type="radio"
                                    name="is_startup"
                                    checked={localInput.is_startup === false}
                                    onChange={() => handleLocalChange('is_startup', false)}
                                /> Non
                            </label>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StepThree;